<c-header-nav *ngIf="available$ | async" class="d-none d-lg-flex">
  <c-nav-item>
    <a cNavLink class="cursor-pointer" title="Suporte" (click)="openSupport()">
      <svg *ngIf="!(loading$ | async)" cIcon name="cilCommentBubble" size="lg"></svg>
      <span *ngIf="loading$ | async" class="spinner-border spinner-border-sm"></span>
    </a>
  </c-nav-item>
</c-header-nav>
